import * as ActionTypes from '../ActionTypes';

export const GetCurrentTimeAction = (params) => {
    return {
        type: ActionTypes.CURRENT_TIME_GET_REQUEST,params
    }
}
